import { SendSmsStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { FrontendStepType, PartialWithRequiredType } from "../steps";
import { SendSmsTemplatePreview } from "./send-sms-template-preview";

export const sendSmsStepType: FrontendStepType<
  PartialWithRequiredType<SendSmsStep>
> = {
  valid: (state) => !!state.templateId,
  type: "custom",
  customInspector: (props) => <SendSmsTemplatePreview {...props} />,
};
